import { Injectable } from '@angular/core';
import { OfflineError } from '../../../errors';
import { isFirebaseUnavailableError } from '../../../firebase';
import { ErrorHandlerMapper } from '../error-handler.models';

@Injectable({ providedIn: 'root' })
export class FirebaseUnavailableMapper
  implements ErrorHandlerMapper<OfflineError>
{
  mapError(error: any) {
    if (isFirebaseUnavailableError(error)) {
      console.error(error?.message, error);
      return new OfflineError(undefined, { error });
    }
    return error;
  }
}
